/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Land_Skin_6_TitleInputs */

const en_land_skin_6_title = /** @type {(inputs: Land_Skin_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lime Carpet`)
};

const ar_land_skin_6_title = /** @type {(inputs: Land_Skin_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سجادة ليموني`)
};

const de_land_skin_6_title = /** @type {(inputs: Land_Skin_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalkteppich`)
};

const es_land_skin_6_title = /** @type {(inputs: Land_Skin_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alfombra de lima`)
};

const fr_land_skin_6_title = /** @type {(inputs: Land_Skin_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prairie Citronnée`)
};

const it_land_skin_6_title = /** @type {(inputs: Land_Skin_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tappeto Lime`)
};

const ja_land_skin_6_title = /** @type {(inputs: Land_Skin_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ライムカーペット`)
};

const ko_land_skin_6_title = /** @type {(inputs: Land_Skin_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`라임 카펫`)
};

const pt_br_land_skin_6_title = /** @type {(inputs: Land_Skin_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relva cítrica`)
};

const ru_land_skin_6_title = /** @type {(inputs: Land_Skin_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лаймовый ковёр`)
};

const th_land_skin_6_title = /** @type {(inputs: Land_Skin_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`พรมสีมะนาว`)
};

const tr_land_skin_6_title = /** @type {(inputs: Land_Skin_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kireç Halı`)
};

const zh_cn_land_skin_6_title = /** @type {(inputs: Land_Skin_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`青柠草毯`)
};

const zh_tw_land_skin_6_title = /** @type {(inputs: Land_Skin_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`青檸草毯`)
};

/**
* | output |
* | --- |
* | "Lime Carpet" |
*
* @param {Land_Skin_6_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const land_skin_6_title = /** @type {((inputs?: Land_Skin_6_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Land_Skin_6_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_land_skin_6_title(inputs)
	if (locale === "ar") return ar_land_skin_6_title(inputs)
	if (locale === "de") return de_land_skin_6_title(inputs)
	if (locale === "es") return es_land_skin_6_title(inputs)
	if (locale === "fr") return fr_land_skin_6_title(inputs)
	if (locale === "it") return it_land_skin_6_title(inputs)
	if (locale === "ja") return ja_land_skin_6_title(inputs)
	if (locale === "ko") return ko_land_skin_6_title(inputs)
	if (locale === "pt_br") return pt_br_land_skin_6_title(inputs)
	if (locale === "ru") return ru_land_skin_6_title(inputs)
	if (locale === "th") return th_land_skin_6_title(inputs)
	if (locale === "tr") return tr_land_skin_6_title(inputs)
	if (locale === "zh_cn") return zh_cn_land_skin_6_title(inputs)
	return zh_tw_land_skin_6_title(inputs)
});